export const PythonIcon = () => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.14286 38.0453C5.19126 38.0453 3.51288 37.3623 2.10773 35.9961C0.702576 34.63 0 32.9321 0 30.9025V21.5348C0 19.5051 0.702576 17.8072 2.10773 16.4411C3.51288 15.075 5.19126 14.3919 7.14286 14.3919H24.9415C24.9415 13.8455 24.7658 13.299 24.4145 12.7526C24.0632 12.2061 23.6534 11.9329 23.185 11.9329H12.5293V7.71744C12.5293 5.76584 13.2123 4.08747 14.5785 2.68231C15.9446 1.27716 17.6425 0.574585 19.6721 0.574585H30.3279C32.2795 0.574585 33.9578 1.27716 35.363 2.68231C36.7682 4.08747 37.4707 5.76584 37.4707 7.71744V17.0851C37.4707 19.1148 36.7682 20.8127 35.363 22.1788C33.9578 23.5449 32.2795 24.228 30.3279 24.228H17.2131C15.2615 24.228 13.5831 24.9306 12.178 26.3357C10.7728 27.7409 10.0703 29.4192 10.0703 31.3708V38.0453H7.14286ZM47.8923 15.2116C46.4871 13.8064 44.8087 13.1039 42.8571 13.1039H39.8126V19.7783C39.8126 21.7299 39.1296 23.4083 37.7635 24.8135C36.3973 26.2186 34.7385 26.9212 32.7869 26.9212H19.6721C17.6425 26.9212 15.9446 27.6238 14.5785 29.0289C13.2123 30.4341 12.5293 32.1124 12.5293 34.064V43.4317C12.5293 45.3833 13.2123 47.0617 14.5785 48.4669C15.9446 49.872 17.6425 50.5746 19.6721 50.5746H30.3279C32.2795 50.5746 33.9578 49.872 35.363 48.4669C36.7682 47.0617 37.4707 45.3833 37.4707 43.4317V39.2163H26.6979C26.3076 39.2163 25.9173 38.943 25.5269 38.3966C25.1366 37.8502 24.9415 37.3427 24.9415 36.8744H42.8571C44.8087 36.8744 46.4871 36.1718 47.8923 34.7666C49.2974 33.3615 50 31.6831 50 29.7315V20.2467C50 18.2951 49.2974 16.6167 47.8923 15.2116ZM30.3279 44.8369C30.3279 43.3537 30.9133 42.6121 32.0843 42.6121C33.2553 42.6121 33.8408 43.3537 33.8408 44.8369C33.8408 45.3053 33.6846 45.7151 33.3724 46.0664C33.0601 46.4177 32.6308 46.5933 32.0843 46.5933C30.9133 46.5933 30.3279 46.0078 30.3279 44.8369ZM19.6721 6.42939C19.6721 7.9126 19.0476 8.65421 17.7986 8.65421C16.6276 8.65421 16.0422 7.9126 16.0422 6.42939C16.0422 5.25843 16.6276 4.67295 17.7986 4.67295C19.0476 4.67295 19.6721 5.25843 19.6721 6.42939Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FinanceIcon = () => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2105 26.8904L26.3158 34.7851V0.574585H34.2105V26.8904ZM16.9211 27.7325L21.0526 31.2588V11.1009H13.1579V31.2062L16.9211 27.7325ZM0 43.8377L7.89474 36.1009V21.6272H0V43.8377ZM36.8421 21.6272L41.6053 26.3904L26.3158 41.7325L17.0263 33.8904L0 50.5746H7.23684L17.1842 40.943L26.3158 48.8904L45.2895 30.0746L50 34.7851V21.6272H36.8421Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SocialManagementIcon = () => {
  return (
    <svg
      width="50"
      height="44"
      viewBox="0 0 50 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5417 6.10352e-05C42.5687 6.10352e-05 45.8333 3.26465 45.8333 7.29173C45.8333 11.3188 42.5687 14.5834 38.5417 14.5834C34.5146 14.5834 31.25 11.3188 31.25 7.29173C31.25 3.26465 34.5146 6.10352e-05 38.5417 6.10352e-05ZM32.2917 19.7917C32.2917 15.7647 29.0271 12.5001 25 12.5001C20.9729 12.5001 17.7083 15.7647 17.7083 19.7917C17.7083 23.8188 20.9729 27.0834 25 27.0834C29.0271 27.0834 32.2917 23.8188 32.2917 19.7917ZM3.64583 16.6667H16.1583C15.8125 17.6459 15.625 18.6959 15.625 19.7917C15.625 22.5626 16.8292 25.0563 18.7417 26.7709L19.1083 27.0834H17.1875C14.5583 27.0834 12.3417 28.8542 11.6667 31.2709L11.5979 31.2688C4.94583 31.2688 0.902083 29.1646 0.0291667 24.7855L0 24.4792V20.3126C0 18.3001 1.63333 16.6667 3.64583 16.6667ZM46.3542 16.6667H33.8417C34.1875 17.6459 34.375 18.6959 34.375 19.7917C34.3775 22.6243 33.0967 25.3054 30.8917 27.0834H32.8125L33.1854 27.0959C35.611 27.2542 37.6731 28.9247 38.3312 31.2646L38.6813 31.2688C45.3583 31.2688 49.3375 29.1396 49.9833 24.7084L50 24.4834V20.3126C50 18.3001 48.3667 16.6667 46.3542 16.6667ZM36.4583 32.8126C36.4583 30.8001 34.825 29.1667 32.8125 29.1667H17.1875C15.175 29.1667 13.5417 30.8001 13.5417 32.8126V36.9792L13.5708 37.2855C14.4438 41.6646 18.4875 43.7688 25.1396 43.7688C31.8167 43.7688 35.7958 41.6396 36.4417 37.2084L36.4583 36.9834V32.8126ZM18.75 7.29173C18.75 3.26465 15.4854 6.10352e-05 11.4583 6.10352e-05C7.43126 6.10352e-05 4.16667 3.26465 4.16667 7.29173C4.16667 11.3188 7.43126 14.5834 11.4583 14.5834C15.4854 14.5834 18.75 11.3188 18.75 7.29173Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ClimateChangeIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6475 0C42.241 0 50 7.75905 50 17.3525C49.9992 26.1396 43.4301 33.5392 34.705 34.5811V44.1993H42.1418V49.1572H2.47893V36.7625H0V26.8468C0 25.4834 1.11552 24.3679 2.47893 24.3679H9.91572C11.2791 24.3679 12.3946 25.4834 12.3946 26.8468V36.7625H9.91572V44.1993H29.7471V34.4323C21.4017 33.0383 15.2885 25.8135 15.295 17.3525C15.295 7.75905 23.054 0 32.6475 0ZM9.91572 18.1706C9.91572 20.2281 8.25483 21.8889 6.19732 21.8889C4.13981 21.8889 2.47893 20.2281 2.47893 18.1706C2.47893 16.113 4.13981 14.4522 6.19732 14.4522C8.25483 14.4522 9.91572 16.113 9.91572 18.1706Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DigitalMarketingIcon = () => {
  return (
    <svg
      width="43"
      height="51"
      viewBox="0 0 43 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0469 0.574585V50.5746L42.8297 40.3933V7.52458L30.0469 0.574585ZM24.1047 39.6543L13.8172 44.1465V4.92146L24.1047 7.96521V39.6543ZM7.86875 36.423L0 38.498L0.03125 10.1215L7.86875 11.384V36.423Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GreenTechIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 50C11.1891 50 0 38.8109 0 25C0 18.3672 2.6375 12.0109 7.325 7.32343C17.0828 -2.4422 32.9188 -2.4422 42.6766 7.32343C52.4422 17.0812 52.4422 32.9172 42.6766 42.675C37.998 47.3777 31.6336 50.0151 25 50ZM25.0813 46.9734C21.7531 46.9734 19.5234 43.5391 20.8906 40.4953L15.2672 36.7515C11.3859 40.8047 5.02187 35.6859 8.14688 31.0219C11.2719 26.3672 18.425 30.3219 16.1391 35.4406L21.7703 39.1922C21.9406 39.0125 22.1281 38.85 22.3234 38.7031L13.3062 20.6609C7.92656 22.3297 4.83438 14.7281 9.84688 12.1641C14.8687 9.60936 19.2062 16.5672 14.7047 19.9437L23.7219 37.9859C23.8829 37.9378 24.0461 37.8971 24.2109 37.864V29.2625C19.2391 28.3109 19.2391 21.1891 24.2109 20.2375V12.1312C18.6937 11.0656 19.5484 2.91874 25.1719 3.02499C30.7953 3.13124 31.3484 11.3016 25.7906 12.1641V20.2125C30.9828 21.0094 30.9828 28.4969 25.7906 29.2953V37.8328C25.9609 37.8578 26.1328 37.8984 26.2953 37.939L35.2953 19.9453C30.8109 16.5687 35.1484 9.64217 40.1453 12.1984C45.1422 14.7547 42.0578 22.3219 36.6953 20.6625L27.7188 38.6156C27.9297 38.7625 28.125 38.925 28.3047 39.1047L33.7484 35.4016C31.2984 30.3312 38.3469 26.1406 41.6344 30.7141C44.9141 35.2875 38.6891 40.6265 34.6688 36.6797L29.225 40.3828C30.6984 43.4344 28.4766 46.975 25.0828 46.975L25.0813 46.9734ZM1.57031 25C1.57031 12.0609 12.0609 1.5703 25 1.5703C31.275 1.55339 37.2908 4.0714 41.6828 8.55311C50.7969 17.7328 50.7484 32.5687 41.5609 41.6828C32.3812 50.7969 17.5531 50.7484 8.43906 41.5609C4.04375 37.175 1.57031 31.2094 1.57031 25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CleanEnergyIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.0667 25.2583C24.0896 25.3077 23.2723 24.6507 22.4785 24.0952L21.0278 44.4167H28.5501L27.0292 24.65C26.4515 25.0463 25.7673 25.2582 25.0667 25.2577V25.2583Z"
        fill="currentColor"
      />
      <path
        d="M22.4771 16.9708C22.4803 17.0148 22.4921 17.0578 22.5118 17.0972C22.5933 17.2249 22.7214 17.3158 22.8688 17.3507C23.7323 16.6106 24.9138 16.3623 26.0021 16.6923C26.3294 16.3302 26.526 15.8689 26.5604 15.3819C26.564 14.9046 26.4897 14.4298 26.3403 13.9764C25.7881 11.875 25.1219 9.80525 24.3445 7.77637C24.1238 7.15774 23.8283 6.56841 23.4646 6.02151C23.2626 5.69332 22.9547 5.44392 22.5917 5.31457C22.2137 5.19581 21.8071 5.38244 21.6507 5.74651C21.6176 5.88758 21.611 6.03359 21.6313 6.17707L22.4771 16.9708Z"
        fill="currentColor"
      />
      <circle cx="24.9625" cy="20.1014" r="0.939583" fill="currentColor" />
      <path
        d="M23.6285 24.4055C23.6651 24.3809 23.6965 24.3493 23.7209 24.3125C23.7907 24.178 23.8054 24.0215 23.7619 23.8764C22.6891 23.4986 21.8833 22.5993 21.625 21.4917C21.1477 21.3894 20.65 21.4501 20.2112 21.6639C19.7958 21.8993 19.4217 22.2009 19.1035 22.5569C17.56 24.0859 16.1009 25.6977 14.7327 27.3854C14.3073 27.8856 13.9446 28.436 13.6528 29.0243C13.4695 29.3634 13.4076 29.7549 13.4771 30.134C13.5632 30.5208 13.9285 30.7798 14.3216 30.7333C14.4605 30.6917 14.5903 30.6243 14.7049 30.5347L23.6285 24.4055Z"
        fill="currentColor"
      />
      <path
        d="M29.4916 19.691C29.4519 19.6716 29.4087 19.6603 29.3645 19.6577C29.2132 19.6646 29.0705 19.7301 28.9666 19.8403C29.1755 20.9578 28.7997 22.1047 27.9701 22.882C28.1201 23.3472 28.4215 23.7479 28.8256 24.0208C29.2373 24.2631 29.6858 24.4364 30.1534 24.534C32.2492 25.1063 34.3745 25.5639 36.5201 25.9049C37.1659 26.0229 37.8243 26.0625 38.4798 26.0208C38.865 26.0099 39.235 25.8678 39.5284 25.6181C39.8201 25.35 39.8618 24.9049 39.625 24.5875C39.5194 24.4881 39.3962 24.4092 39.2618 24.3549C36.0048 22.7993 32.7479 21.2452 29.4909 19.691H29.4916Z"
        fill="currentColor"
      />
      <path
        d="M22.9278 26.9423L21.5834 44.4166H28.55L27.0292 24.65"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4771 16.9708C22.4803 17.0148 22.4921 17.0578 22.5118 17.0972C22.5933 17.2249 22.7214 17.3158 22.8688 17.3507C23.7323 16.6106 24.9138 16.3623 26.0021 16.6923C26.3294 16.3302 26.526 15.8689 26.5604 15.3819C26.564 14.9046 26.4897 14.4298 26.3403 13.9764C25.7881 11.875 25.1219 9.80525 24.3445 7.77637C24.1238 7.15774 23.8283 6.56841 23.4646 6.02151C23.2626 5.69332 22.9547 5.44392 22.5917 5.31457C22.2137 5.19581 21.8071 5.38244 21.6507 5.74651C21.6176 5.88758 21.611 6.03359 21.6313 6.17707L22.4771 16.9708V16.9708Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6285 24.4055C23.6651 24.3809 23.6965 24.3493 23.7209 24.3125C23.7907 24.178 23.8054 24.0215 23.7619 23.8764C22.6891 23.4986 21.8833 22.5993 21.625 21.4917C21.1477 21.3894 20.65 21.4501 20.2112 21.6639C19.7958 21.8993 19.4217 22.2009 19.1035 22.5569C17.56 24.0859 16.1009 25.6977 14.7327 27.3854C14.3073 27.8856 13.9446 28.436 13.6528 29.0243C13.4695 29.3634 13.4076 29.7549 13.4771 30.134C13.5632 30.5208 13.9285 30.7798 14.3216 30.7333C14.4605 30.6917 14.5903 30.6243 14.7049 30.5347L23.6285 24.4055V24.4055Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4916 19.6909C29.4519 19.6715 29.4087 19.6602 29.3645 19.6576C29.2132 19.6645 29.0705 19.73 28.9666 19.8402C29.1755 20.9578 28.7997 22.1046 27.9701 22.8819C28.1201 23.3472 28.4215 23.7479 28.8256 24.0208C29.2373 24.263 29.6858 24.4363 30.1534 24.534C32.2492 25.1062 34.3745 25.5639 36.5201 25.9048C37.1659 26.0229 37.8243 26.0625 38.4798 26.0208C38.865 26.0099 39.235 25.8678 39.5284 25.618C39.8201 25.35 39.8618 24.9048 39.625 24.5875C39.5194 24.488 39.3962 24.4091 39.2618 24.3548C36.0048 22.7993 32.7479 21.2451 29.4909 19.6909H29.4916Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="25.2063"
        cy="20.3451"
        r="1.18264"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const JavaScriptIcon = () => {
  return (
    <svg
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1302 1.07552C32.625 4.74045 39.1172 8.40798 45.6068 12.0781C46.8487 12.7852 47.6205 14.0996 47.6328 15.5286V37.599C47.6085 39.0846 46.773 40.4377 45.4557 41.125C38.987 44.7778 32.5182 48.4271 26.0495 52.0729C24.698 52.8199 23.0475 52.774 21.7396 51.9531L15.9167 48.5859C15.4906 48.3962 15.1078 48.1215 14.7917 47.7786C14.9724 47.5352 15.2573 47.4473 15.5378 47.3608C15.6413 47.3289 15.7443 47.2971 15.8411 47.2578C16.6385 46.9725 17.4075 46.6133 18.138 46.1849C18.3264 46.0738 18.5634 46.0882 18.737 46.2213C19.4702 46.6408 20.1994 47.0659 20.9286 47.491C21.8516 48.029 22.7746 48.5671 23.7057 49.0937C24.0126 49.272 24.3235 49.0905 24.5975 48.9304C24.6397 48.9057 24.681 48.8816 24.7214 48.8594C31.0773 45.2795 37.4288 41.6944 43.776 38.1042C44.009 37.9892 44.1475 37.7431 44.125 37.4844V15.6406C44.1472 15.3515 43.9843 15.08 43.7188 14.9635L24.3802 4.06249C24.1511 3.90526 23.8489 3.90526 23.6198 4.06249C17.1753 7.69965 10.73 11.3342 4.28385 14.9661C4.01565 15.0799 3.85076 15.3529 3.875 15.6432V37.4844C3.85248 37.7419 3.99279 37.9861 4.22656 38.0963L9.38802 41.013C10.3538 41.6101 11.5283 41.7673 12.6172 41.4453C13.5752 41.0861 14.2088 40.169 14.2057 39.1458C14.2094 35.7389 14.2085 32.3326 14.2075 28.9266C14.2065 25.0949 14.2054 21.2636 14.2109 17.4323C14.2082 17.2774 14.2712 17.1286 14.3844 17.0228C14.4976 16.9171 14.6503 16.8643 14.8047 16.8776C15.6319 16.8681 16.4592 16.8681 17.2865 16.8776C17.4496 16.8851 17.6019 16.962 17.7048 17.0888C17.8078 17.2157 17.8517 17.3804 17.8255 17.5417C17.8234 20.5398 17.8243 23.5383 17.8253 26.5372C17.8266 30.8213 17.828 35.106 17.8203 39.3906C17.9325 41.4057 16.9397 43.3223 15.2292 44.3932C12.954 45.4532 10.3127 45.3808 8.09896 44.1979C6.9224 43.6104 5.78004 42.9576 4.63813 42.305C3.94255 41.9075 3.24714 41.5101 2.54427 41.1276C1.22498 40.4411 0.388891 39.086 0.367188 37.599V15.5286C0.379017 14.0693 1.18163 12.7313 2.46354 12.0338L21.8672 1.07552C23.1917 0.334854 24.8057 0.334854 26.1302 1.07552ZM24.7578 33.0338C26.5229 33.9023 28.4952 34.2612 30.4531 34.0703C32.0915 34.1949 33.7269 33.7944 35.1224 32.9271C35.7771 32.2887 36.0446 31.3513 35.8255 30.4635C35.625 29.737 34.8646 29.3958 34.2083 29.1745C32.6076 28.6674 30.941 28.4901 29.2746 28.3128C27.4492 28.1186 25.6239 27.9245 23.8854 27.2969C22.4745 26.8833 21.3154 25.8727 20.7135 24.5312C19.9344 22.513 20.3729 20.2272 21.8438 18.6406C23.4149 17.2529 25.4159 16.4483 27.5104 16.362C30.369 15.9927 33.2737 16.4377 35.8906 17.6458C37.8202 18.7969 38.9962 20.8834 38.9818 23.1302C38.9061 23.4157 38.6319 23.6022 38.3385 23.5677C38.0489 23.5668 37.7596 23.5678 37.4705 23.5688C36.9408 23.5707 36.4118 23.5726 35.8828 23.5625C35.5556 23.5424 35.2979 23.2757 35.2891 22.9479C35.101 21.8659 34.4468 20.9212 33.5 20.3646C31.9439 19.7461 30.2635 19.5052 28.5964 19.6615C27.3661 19.6227 26.1493 19.9256 25.0807 20.5365C24.3268 21.1213 24.0293 22.1216 24.3411 23.0234C24.5955 23.6278 25.2785 23.8377 25.8578 24.0157C25.8776 24.0218 25.8972 24.0278 25.9167 24.0338C27.4033 24.4232 28.9288 24.6249 30.4535 24.8265C32.4168 25.0861 34.3789 25.3456 36.2552 26.0052C37.7067 26.4088 38.8895 27.4617 39.4583 28.8568C40.1387 30.8417 39.749 33.0371 38.4271 34.6667C37.2511 35.8871 35.7234 36.7101 34.0573 37.0208C31.8871 37.4619 29.6608 37.5568 27.4609 37.3021C25.3497 37.181 23.3256 36.4188 21.6589 35.1172C20.3223 33.8887 19.6033 32.128 19.6979 30.3151C19.732 30.0162 20.0002 29.8003 20.2995 29.8307C21.1241 29.8224 21.9488 29.8224 22.7734 29.8307C22.9277 29.8279 23.0766 29.8869 23.1871 29.9945C23.2977 30.1021 23.3606 30.2494 23.362 30.4036C23.444 31.4355 23.9492 32.3875 24.7578 33.0338Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TherapyIcon = () => {
  return (
    <svg
      width="46"
      height="50"
      viewBox="0 0 46 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8347 17.4125C38.5328 7.45141 30.0455 0.000654982 19.9997 0C12.3097 0.000189582 5.30086 4.40943 1.97163 11.3414C-1.3576 18.2734 -0.417517 26.5003 4.3897 32.5025C6.4097 35.0225 7.4997 37.815 7.4997 40.765V50H29.9997L30.0022 42.5H34.9997C37.7611 42.5 39.9997 40.2614 39.9997 37.5V30.175L44.8972 28.08C45.7547 27.71 45.8297 26.8425 45.4597 26.26L39.8347 17.4125ZM17.4997 15C17.4997 13.6193 18.619 12.5 19.9997 12.5C21.3804 12.5 22.4997 13.6193 22.4997 15V17.5H24.9997C26.3804 17.5 27.4997 18.6193 27.4997 20C27.4997 21.3807 26.3804 22.5 24.9997 22.5H22.4997V25C22.4997 26.3807 21.3804 27.5 19.9997 27.5C18.619 27.5 17.4997 26.3807 17.4997 25V22.4975L14.9997 22.5C13.619 22.5 12.4997 21.3807 12.4997 20C12.4997 18.6193 13.619 17.5 14.9997 17.5L17.4997 17.4975V15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BackToTop = () => {
  return (
    <svg
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="30.5" cy="30.0755" rx="30.5" ry="30.0755" fill="#00A89A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2976 41.8894C36.7022 42.0012 41.9865 36.8982 42.0983 30.4936C42.2101 24.0875 37.1071 18.8047 30.7025 18.6929C24.2963 18.5811 19.0136 23.6826 18.9018 30.0887C18.79 36.4933 23.8914 41.7776 30.2976 41.8894ZM44.9978 30.5427C44.8581 38.5501 38.2543 44.9287 30.247 44.7889C22.2396 44.6492 15.8625 38.044 16.0023 30.0366C16.142 22.0292 22.7457 15.6536 30.7531 15.7933C38.7605 15.9331 45.1376 22.5353 44.9978 30.5427ZM31.68 23.5123L36.1296 28.5728C36.6938 29.2142 36.2681 30.2865 35.4531 30.2723L33.0908 30.231C32.5858 30.2222 32.1683 30.6647 32.1586 31.219L32.0784 35.8169C32.0615 36.7855 31.3324 37.5568 30.4514 37.5414L30.4192 37.5408C29.5368 37.5254 28.8351 36.7292 28.852 35.7606L28.9322 31.1627C28.9419 30.6084 28.5415 30.1516 28.0365 30.1428L25.6869 30.1018C24.8718 30.0876 24.4839 29.0011 25.07 28.3798L29.6936 23.4777C30.2526 22.8852 31.142 22.9007 31.68 23.5123Z"
        fill="white"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="171"
      height="124"
      viewBox="0 0 171 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62 121H44.2879C38.427 120.994 32.6343 119.752 27.2943 117.356C21.9544 114.959 17.1893 111.463 13.3153 107.1C9.44135 102.737 6.54715 97.6063 4.82481 92.0486C3.10246 86.4909 2.59137 80.6334 3.32545 74.8648C4.05954 69.0961 6.02201 63.5484 9.0826 58.5897C12.1432 53.6311 16.2319 49.3749 21.0774 46.1038C25.9228 42.8327 31.4142 40.6214 37.187 39.6167C42.9597 38.612 48.8819 38.8369 54.5604 40.2765"
        stroke="#E1E1E1"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50 61.7457C50.0009 52.4368 52.2232 43.2613 56.4837 34.9754C60.7442 26.6895 66.9209 19.5303 74.505 14.0877C82.0891 8.64515 90.8633 5.07505 100.105 3.67157C109.346 2.2681 118.79 3.07144 127.659 6.01539C136.527 8.95933 144.566 13.9596 151.114 20.6042C157.661 27.2488 162.529 35.3475 165.316 44.233C168.104 53.1184 168.731 62.5363 167.146 71.7105C165.562 80.8847 161.81 89.5526 156.202 97"
        stroke="#E1E1E1"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M78 87L103 62L128 87"
        stroke="#E1E1E1"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M103 121V62"
        stroke="#E1E1E1"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UploadCSVImage = () => {
  return (
    <svg
      width="154"
      height="194"
      viewBox="0 0 154 194"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7109_221851)">
        <path
          opacity="0.2"
          d="M139.145 0H14.8547C6.65068 0 0 6.65068 0 14.8547V178.909C0 187.113 6.65068 193.763 14.8547 193.763H139.145C147.349 193.763 154 187.113 154 178.909V14.8547C154 6.65068 147.349 0 139.145 0Z"
          fill="#87D4E4"
        />
        <path
          d="M42.9437 32.7344H67.5163C68.1215 32.7344 68.7157 32.8964 69.2371 33.2036C69.7586 33.5109 70.1882 33.9521 70.4815 34.4815L72.6746 38.4398C72.9679 38.9691 73.3976 39.4103 73.919 39.7175C74.4404 40.0247 75.0346 40.1867 75.6398 40.1867H104.342C104.787 40.1867 105.228 40.2744 105.639 40.4448C106.05 40.6151 106.424 40.8648 106.739 41.1796C107.053 41.4944 107.303 41.8681 107.473 42.2794C107.644 42.6907 107.732 43.1315 107.732 43.5767V89.5832C107.732 90.0284 107.644 90.4692 107.473 90.8805C107.303 91.2918 107.053 91.6655 106.739 91.9803C106.424 92.2951 106.05 92.5447 105.639 92.7151C105.228 92.8855 104.787 92.9731 104.342 92.9731H42.9437C42.4985 92.9731 42.0577 92.8855 41.6464 92.7151C41.2351 92.5447 40.8614 92.2951 40.5466 91.9803C40.2318 91.6655 39.9821 91.2918 39.8117 90.8805C39.6414 90.4692 39.5537 90.0284 39.5537 89.5832V36.1243C39.5537 35.6792 39.6414 35.2384 39.8117 34.8271C39.9821 34.4158 40.2318 34.042 40.5466 33.7273C40.8614 33.4125 41.2351 33.1628 41.6464 32.9924C42.0577 32.8221 42.4985 32.7344 42.9437 32.7344Z"
          fill="#F3F3F4"
        />
        <path
          d="M31.6875 31.176V75.7408C31.6876 76.5837 32.0223 77.3922 32.6182 77.9884C33.2141 78.5846 34.0223 78.9198 34.8652 78.9204H80.2638C81.1068 78.9198 81.915 78.5846 82.5109 77.9884C83.1067 77.3922 83.4415 76.5837 83.4416 75.7408V20.1874C83.4415 19.3444 83.1067 18.536 82.5109 17.9398C81.915 17.3436 81.1068 17.0084 80.2638 17.0078H45.1679L31.6875 31.176Z"
          fill="#87D4E4"
        />
        <path
          d="M45.1679 17.0078V27.9965C45.168 28.4139 45.0859 28.8273 44.9262 29.213C44.7666 29.5987 44.5325 29.9492 44.2374 30.2444C43.9423 30.5397 43.592 30.7739 43.2064 30.9337C42.8207 31.0936 42.4074 31.1759 41.99 31.176H31.6875L45.1679 17.0078Z"
          fill="white"
        />
        <path
          d="M40.6742 41.6016L74.4525 41.6016C75.6938 41.6016 76.7002 40.5952 76.7002 39.3538V39.3525C76.7002 38.1111 75.6938 37.1048 74.4525 37.1048L40.6742 37.1048C39.4328 37.1048 38.4265 38.1111 38.4265 39.3525V39.3538C38.4265 40.5952 39.4328 41.6016 40.6742 41.6016Z"
          fill="white"
        />
        <path
          d="M40.6742 51.2656L74.4525 51.2656C75.6938 51.2656 76.7002 50.2593 76.7002 49.0179V49.0164C76.7002 47.775 75.6938 46.7687 74.4525 46.7687L40.6742 46.7687C39.4328 46.7687 38.4265 47.775 38.4265 49.0164V49.0179C38.4265 50.2593 39.4328 51.2656 40.6742 51.2656Z"
          fill="white"
        />
        <path
          d="M75.1108 60.9297H59.1526C58.9439 60.9297 58.7372 60.8886 58.5444 60.8087C58.3516 60.7288 58.1764 60.6118 58.0288 60.4642C57.8812 60.3166 57.7641 60.1414 57.6842 59.9486C57.6044 59.7557 57.5633 59.549 57.5633 59.3403V58.0225C57.5633 57.6009 57.7307 57.1966 58.0288 56.8985C58.3269 56.6004 58.7312 56.4329 59.1528 56.4329H75.1107C75.5322 56.4329 75.9365 56.6004 76.2346 56.8985C76.5327 57.1966 76.7002 57.6009 76.7002 58.0225V59.3403C76.7002 59.549 76.6591 59.7557 76.5792 59.9486C76.4993 60.1414 76.3823 60.3166 76.2347 60.4642C76.0871 60.6118 75.9119 60.7288 75.7191 60.8087C75.5262 60.8886 75.3196 60.9297 75.1108 60.9297Z"
          fill="white"
        />
        <path
          d="M54.5419 50.5781H119.327C119.863 50.5781 120.39 50.7048 120.867 50.9478C121.344 51.1908 121.756 51.5432 122.07 51.9762C122.385 52.4092 122.592 52.9105 122.676 53.4391C122.759 53.9676 122.716 54.5084 122.551 55.0173L110.956 90.6369C110.734 91.3173 110.303 91.9101 109.724 92.3306C109.145 92.751 108.448 92.9774 107.732 92.9774H42.9471C42.4119 92.9775 41.8844 92.8508 41.4076 92.6078C40.9309 92.3648 40.5184 92.0124 40.204 91.5794C39.8896 91.1464 39.6821 90.6451 39.5986 90.1165C39.5151 89.5879 39.558 89.0471 39.7236 88.5383L51.3185 52.9187C51.54 52.2383 51.9711 51.6454 52.5501 51.225C53.1292 50.8046 53.8264 50.5781 54.5419 50.5781Z"
          fill="white"
        />
        <path
          d="M100.618 58.2814H121.488L124.076 50.33C124.242 49.8211 124.284 49.2803 124.201 48.7517C124.117 48.2231 123.91 47.7218 123.596 47.2888C123.281 46.8558 122.869 46.5033 122.392 46.2603C121.915 46.0173 121.388 45.8906 120.852 45.8906H107.113C106.398 45.8906 105.7 46.117 105.121 46.5375C104.542 46.9579 104.111 47.5508 103.89 48.2312L100.618 58.2814Z"
          fill="white"
        />
        <path
          d="M123.905 88.9055C125.08 81.6672 120.164 74.8473 112.926 73.6727C105.688 72.4981 98.8678 77.4137 97.6932 84.6519C96.5186 91.8901 101.434 98.71 108.672 99.8846C115.911 101.059 122.73 96.1437 123.905 88.9055Z"
          fill="#00A89A"
        />
        <path
          d="M102.741 89.433L109.395 96.087C109.581 96.2723 109.802 96.4189 110.045 96.5182L110.075 96.528C110.54 96.7158 111.059 96.7158 111.524 96.528L111.555 96.5182C111.798 96.4188 112.018 96.2723 112.204 96.087L118.858 89.433C119.23 89.0604 119.439 88.5553 119.439 88.0289C119.439 87.5024 119.229 86.9975 118.857 86.6252C118.485 86.2529 117.98 86.0437 117.453 86.0434C116.927 86.0432 116.422 86.252 116.049 86.6239L112.786 89.8869V78.8693C112.786 78.3425 112.577 77.8372 112.204 77.4646C111.832 77.0921 111.327 76.8828 110.8 76.8828C110.273 76.8828 109.768 77.0921 109.395 77.4646C109.022 77.8372 108.813 78.3425 108.813 78.8693V89.8869L105.55 86.6239C105.178 86.252 104.673 86.0432 104.146 86.0434C103.62 86.0437 103.115 86.2529 102.742 86.6252C102.37 86.9975 102.161 87.5024 102.161 88.0289C102.16 88.5553 102.369 89.0604 102.741 89.433Z"
          fill="white"
        />
        <path
          d="M69.8965 116.109H24.9937C24.0608 116.109 23.137 116.293 22.2751 116.65C21.4132 117.007 20.63 117.53 19.9704 118.19C19.3107 118.85 18.7874 119.633 18.4304 120.495C18.0734 121.357 17.8896 122.281 17.8896 123.213C17.8897 125.098 18.6381 126.904 19.9704 128.237C21.3027 129.569 23.1096 130.317 24.9937 130.317H69.8965C71.7806 130.317 73.5876 129.569 74.9198 128.237C76.2521 126.904 77.0005 125.098 77.0006 123.213C77.0006 122.281 76.8168 121.357 76.4598 120.495C76.1028 119.633 75.5795 118.85 74.9199 118.19C74.2602 117.53 73.477 117.007 72.6151 116.65C71.7532 116.293 70.8294 116.109 69.8965 116.109Z"
          fill="#87D4E4"
        />
        <path
          d="M129.007 137.82H24.9937C24.0608 137.82 23.137 138.004 22.2751 138.361C21.4132 138.718 20.63 139.241 19.9704 139.901C19.3107 140.561 18.7874 141.344 18.4304 142.206C18.0734 143.068 17.8896 143.991 17.8896 144.924C17.8897 145.857 18.0734 146.781 18.4304 147.643C18.7875 148.505 19.3107 149.288 19.9704 149.948C20.6301 150.607 21.4132 151.131 22.2751 151.488C23.137 151.845 24.0608 152.028 24.9937 152.028H129.007C129.94 152.028 130.864 151.845 131.726 151.488C132.588 151.131 133.371 150.607 134.031 149.948C134.69 149.288 135.214 148.505 135.571 147.643C135.928 146.781 136.111 145.857 136.112 144.924C136.112 143.991 135.928 143.068 135.571 142.206C135.214 141.344 134.69 140.561 134.031 139.901C133.371 139.241 132.588 138.718 131.726 138.361C130.864 138.004 129.94 137.82 129.007 137.82Z"
          fill="#87D4E4"
        />
        <path
          d="M24.9937 159.531H129.007C130.892 159.531 132.698 160.28 134.031 161.612C135.363 162.944 136.112 164.751 136.112 166.635C136.112 167.568 135.928 168.492 135.571 169.354C135.214 170.216 134.69 170.999 134.031 171.658C133.371 172.318 132.588 172.841 131.726 173.198C130.864 173.555 129.94 173.739 129.008 173.739H24.9935C23.1095 173.739 21.3026 172.991 19.9703 171.659C18.6381 170.326 17.8896 168.519 17.8896 166.635C17.8896 164.751 18.6381 162.944 19.9704 161.612C21.3026 160.28 23.1096 159.531 24.9937 159.531Z"
          fill="#87D4E4"
        />
      </g>
      <defs>
        <clipPath id="clip0_7109_221851">
          <rect width="154" height="193.763" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SuccessIcon = () => {
  return (
    <svg
      width="148"
      height="148"
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M74 148C114.869 148 148 114.869 148 74C148 33.1309 114.869 0 74 0C33.1309 0 0 33.1309 0 74C0 114.869 33.1309 148 74 148Z"
        fill="url(#paint0_linear_9064_395)"
      />
      <path
        d="M58.2302 114.934L25.2302 81.9337C24.2148 80.9603 23.4038 79.7941 22.8449 78.5033C22.286 77.2126 21.9903 75.8232 21.9752 74.4167C21.9601 73.0102 22.2259 71.6149 22.757 70.3124C23.288 69.0099 24.0737 67.8265 25.068 66.8316C26.0623 65.8367 27.2451 65.0502 28.5472 64.5182C29.8493 63.9863 31.2445 63.7196 32.6511 63.7337C34.0576 63.7479 35.4471 64.0427 36.7382 64.6007C38.0294 65.1588 39.1962 65.9689 40.1702 66.9837L58.2802 85.1037L107.63 36.3137C109.649 34.5011 112.288 33.5345 115 33.6139C117.713 33.6933 120.29 34.8128 122.2 36.7404C124.11 38.668 125.205 41.2562 125.259 43.969C125.313 46.6819 124.322 49.3116 122.49 51.3137L58.2302 114.934Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9064_395"
          x1="-61.8072"
          y1="50.3212"
          x2="77.3224"
          y2="173.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D3CA" />
          <stop offset="1" stopColor="#00A89A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
